// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2Qtv5","infoBtn":"quickbooks_infoBtn__Tp1Ac","formBox":"quickbooks_formBox__2OIK0","formFooter":"quickbooks_formFooter__3G5oa"};